/**
 * Lot B2 (Eric 2026-06-30) — Dire POURQUOI il n'y a qu'un locuteur.
 *
 * Une vidéo jamais diarisée est indiscernable d'une vidéo où une seule
 * personne parle : dans les deux cas, un seul nom sur tous les segments. C'est
 * ce qui a permis à la coupure du 23/09 de passer un mois inaperçue.
 */
const MOTIFS = {
  kill_switch_bypass: {
    fr: "Cette vidéo n'a PAS été diarisée : l'interrupteur global de diarisation était actif au moment du traitement. Le locuteur unique affiché n'est pas un constat, c'est un défaut.",
    en: "This video was NOT diarized: the global diarization switch was active. The single speaker shown is a fallback, not a finding.",
  },
  user_skip_default: {
    fr: "Diarisation désactivée sur cette vidéo : tous les segments portent un locuteur unique par défaut.",
    en: "Diarization disabled on this video: all segments carry a single default speaker.",
  },
  user_assigned_single: {
    fr: "Locuteur unique assigné à l'import : aucune diarisation n'a été demandée.",
    en: "Single speaker assigned at import: no diarization was requested.",
  },
  // Tâche 1300 — La diarisation a été tentée et REFUSÉE par le fournisseur.
  // Avant, on répartissait les segments en alternance sur les locuteurs
  // cochés : une attribution inventée, indiscernable d'une vraie.
  assemblyai_unavailable: {
    fr: "La diarisation a été tentée mais AssemblyAI l'a refusée (solde du compte, clé ou service). Aucun locuteur n'est attribué : rien n'a été inventé. Corrigez la cause, puis relancez « Réappliquer la diarisation ». Le journal du pipeline indique le motif exact.",
    en: "Diarization was attempted but AssemblyAI refused it (account balance, key or service). No speaker is assigned — nothing was invented. Fix the cause, then re-run diarization. The pipeline log shows the exact reason.",
  },
};

export const NonDiariseeBanner = ({ segments, lang }) => {
  const list = segments || [];
  if (!list.length) return null;
  const sources = new Set(list.map((s) => s.diarization_source).filter(Boolean));
  if (sources.size !== 1) return null;
  const source = [...sources][0];
  const motif = MOTIFS[source];
  if (!motif) return null;
  const grave = source === "kill_switch_bypass" || source === "assemblyai_unavailable";

  return (
    <div
      className={`p-3 rounded-lg border flex items-start gap-3 ${
        grave ? "bg-amber-50 border-amber-400" : "bg-zinc-50 border-zinc-300"
      }`}
      data-testid="speakers-not-diarized-banner"
    >
      <span className="text-lg leading-none flex-shrink-0">{grave ? "⚠" : "ℹ"}</span>
      <div className="min-w-0">
        <p className={`text-sm font-semibold ${grave ? "text-amber-900" : "text-zinc-800"}`}>
          {lang === "fr" ? "Un seul locuteur — voici pourquoi" : "Single speaker — here is why"}
        </p>
        <p className={`text-xs mt-0.5 ${grave ? "text-amber-800" : "text-zinc-600"}`}>
          {lang === "fr" ? motif.fr : motif.en}
        </p>
        {grave && (
          <p className="text-xs mt-1 text-amber-800">
            {lang === "fr"
              ? "Relance « Réappliquer la diarisation » pour obtenir les vrais locuteurs."
              : "Use « Reapply diarization » to get the real speakers."}
          </p>
        )}
      </div>
    </div>
  );
};

export default NonDiariseeBanner;
